import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AcademicPlanStatusService from "../../src/Services/AcademicPlanStatus.service";
const AcademicPlanStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "name",
        fetchItemsById: (ids) => {
            return AcademicPlanStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return AcademicPlanStatusService.searchAll(search);
        },
        optionRenderer: function optionRenderer(academicPlanStatus) {
            return _jsx("span", { children: academicPlanStatus.name });
        },
    });
};
export default AcademicPlanStatusLookup;
